module.exports = __webpack_public_path__ + "img/navlogo.16f4e8a1.png";